// extracted by mini-css-extract-plugin
module.exports = {"landing-menu":"styles_landing-menu__zWsYX","item":"styles_item__Kuffd","inverse-button":"styles_inverse-button__GlLTr","badge-wrapper":"styles_badge-wrapper__SqRvY"};